import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { NewRequestMenuItemsEnum } from "./new-request-menu-items.enum";
import { RequestType } from "../../../../shared/enums";

class MenuItem {
    index: number;
    name: string;
    isError: boolean;
    isSuccess: boolean;
    selected: boolean;
    iconClass: string;
    hidden: boolean;
}

export class MenuItemState {
    index: number;
    isError: boolean;
    isDefault: boolean;
}

@Component({
    selector: 'new-request-menu',
    templateUrl: './new-request-menu.component.html',
    styleUrls: ['./new-request-menu.component.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ]
})
export class NewRequestMenuComponent implements OnChanges {

    @Input() requestTypeId: number;
    @Input() itemStates: MenuItemState[] = [];

    @Output() selectItemEvent: EventEmitter<number> = new EventEmitter<number>();

    menuItems: MenuItem[] = [{
        index: NewRequestMenuItemsEnum.clientInfo,
        name: 'Информация о клиенте',
        isError: false,
        isSuccess: false,
        selected: true,
        iconClass: "request-client-info-icon",
        hidden: false,
    }, {
        index: NewRequestMenuItemsEnum.requestInfo,
        name: 'Информация по заявке',
        isError: false,
        isSuccess: false,
        selected: false,
        iconClass: "request-info-icon",
        hidden: false,
    }, {
        index: NewRequestMenuItemsEnum.customerObjectInfo,
        name: 'Информация об объекте',
        isError: false,
        isSuccess: false,
        selected: false,
        iconClass: "request-customer-object-info-icon",
        hidden: false,
    }, {
        index: NewRequestMenuItemsEnum.contacts,
        name: 'Контакты',
        isError: false,
        isSuccess: false,
        selected: false,
        iconClass: "request-contacts-icon",
        hidden: false,
    }, {
        index: NewRequestMenuItemsEnum.servicesAndDevices,
        name: 'Услуги и оборудование',
        isError: false,
        isSuccess: false,
        selected: false,
        iconClass: "request-services-and-devices-icon",
        hidden: false,
    }, {
        index: NewRequestMenuItemsEnum.clientRequestHistory,
        name: 'История заявок',
        isError: false,
        isSuccess: false,
        selected: false,
        iconClass: "request-history-icon",
        hidden: true,
    }];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.requestTypeId || changes.itemStates) {
            this.refreshMenuItems();
        }
    }

    selectItem(item: MenuItem) {
        this.changeState(item.index, true);
        this.selectItemEvent.emit(item.index);
    }

    refreshMenuItems() {
        let historyItem = this.menuItems.find(x => x.index == NewRequestMenuItemsEnum.clientRequestHistory);
        historyItem.hidden = this.requestTypeId != <number>RequestType.reclamation;

        let servicesAndDevicesItem = this.menuItems.find(x => x.index == NewRequestMenuItemsEnum.servicesAndDevices);
        servicesAndDevicesItem.hidden = this.requestTypeId == <number>RequestType.personalWarehouseReplenishment;

        this.itemStates.forEach(state => {
            let menuItem = this.menuItems.find(x => x.index == state.index);
            menuItem.isError = state.isError;
            menuItem.isSuccess = !state.isError && !state.isDefault;
        });
    }

    changeState(index: number, selected: boolean) {
        this.menuItems.forEach(x => x.selected = false);
        let item = this.menuItems.find(x => x.index == index);
        item.selected = selected;
    }

    get visibleMenuItems(): MenuItem[] {
        return this.menuItems.filter(x => !x.hidden);
    }
}